import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';
import { hasAnyPrivilege } from '../utils/auth';

/**
 * Protected Route Component
 * Checks authentication and privileges before allowing access to a route
 * 
 * @param {Object} props
 * @param {React.Component} props.children - Component to render if access is granted
 * @param {Array} props.requiredPrivileges - Privilege codes required to access (optional) - TODO: Will be implemented later
 * @param {boolean} props.requireAuth - Whether authentication is required (default: true)
 */
const ProtectedRoute = ({ 
  children, 
  requiredPrivileges = [],
  requireAuth = true 
}) => {
  // Check authentication
  if (requireAuth && !isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Check privileges if required
  if (requiredPrivileges && requiredPrivileges.length > 0) {
    if (!hasAnyPrivilege(requiredPrivileges)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

/**
 * Route Guard Hook
 * Can be used in components to check access
 * TODO: Will be implemented when privileges are enabled
 */
export const useRouteGuard = (path) => {
  // TODO: Privileges will be implemented later
  // const menuItem = getMenuItemByPath(path);
  
  // if (!menuItem) {
  //   // If path is not in menu config, allow access (for public routes)
  //   return { hasAccess: true };
  // }

  // if (!menuItem.requiredPrivileges || menuItem.requiredPrivileges.length === 0) {
  //   // No privileges required
  //   return { hasAccess: true };
  // }

  // const hasAccess = hasAnyPrivilege(menuItem.requiredPrivileges);
  
  // For now, allow access to all authenticated users
  return { 
    hasAccess: true,
    requiredPrivileges: [] 
  };
};

export default ProtectedRoute;


